// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"SpinnerDots_wrapper__5jbzn","fade-out":"SpinnerDots_fade-out__VvNlP","fadeIn":"SpinnerDots_fadeIn__eAvmh"};